import { L, vocabulary } from '../define.js';
/** D577 slice a — generated from the domain code lists; every vocabulary is typed against its source. */
export const MISC_API_VIEWS_VOCABULARIES = [
    vocabulary('partner_spend.grain', '@vello/api-client PartnerSpendGrain', {
        day: L('Por dia', 'By day', 'Por día', 'Per giorno'),
        week: L('Por semana', 'By week', 'Por semana', 'Per settimana'),
        month: L('Por mês', 'By month', 'Por mes', 'Per mese'),
    }),
    vocabulary('award.status', '@vello/api-client AwardStatusView', {
        PROPOSED: L('Aguardando decisão', 'Awaiting decision', 'A la espera de decisión', 'In attesa di decisione'),
        ACTIVE: L('Ativa', 'Active', 'Activa', 'Attiva'),
        REJECTED: L('Rejeitada', 'Rejected', 'Rechazada', 'Rifiutata'),
        ENDED: L('Encerrada', 'Ended', 'Terminada', 'Terminata'),
    }),
    vocabulary('common.client_app', '@vello/m12-e2e ClientApp (cycle-prone package — typed locally)', {
        rider: L('App do passageiro', 'Rider app', 'App del pasajero', 'App del passeggero'),
        driver: L('App do motorista', 'Driver app', 'App del conductor', 'App dell’autista'),
        admin: L('Painel administrativo', 'Admin console', 'Panel administrativo', 'Console di amministrazione'),
    }),
];
//# sourceMappingURL=misc-api-views.js.map